package com.nnod.landing

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nnod.landing.nodin.NodInEndLabels
import com.nnod.landing.nodin.NodInEndPhase
import com.nnod.landing.nodin.NodInEndScreen
import com.nnod.landing.nodin.NodInEndState
import com.nnod.landing.nodin.NodInLandingKind
import com.nnod.landing.nodin.appDeepLink
import com.nnod.landing.nodin.qrPayload
import com.nnod.landing.web.LandingRoute
import com.nnod.landing.web.getBrowserPathname
import com.nnod.landing.web.openDeepLink
import com.nnod.landing.web.parseLandingRoute
import com.nnod.ui.theme.NnodTheme
import nnod.landing.generated.resources.Res
import nnod.landing.generated.resources.landing_footer
import nnod.landing.generated.resources.nodin_code_input_label
import nnod.landing.generated.resources.nodin_end_badge
import nnod.landing.generated.resources.nodin_end_not_found_body
import nnod.landing.generated.resources.nodin_end_not_found_title
import nnod.landing.generated.resources.nodin_end_time_label
import nnod.landing.generated.resources.nodin_instructions_step1
import nnod.landing.generated.resources.nodin_instructions_step2
import nnod.landing.generated.resources.nodin_instructions_title
import nnod.landing.generated.resources.nodin_open_app
import nnod.landing.generated.resources.nodin_or_divider
import nnod.landing.generated.resources.nodin_page_title
import nnod.landing.generated.resources.nodin_start_badge
import nnod.landing.generated.resources.nodin_start_time_label
import org.jetbrains.compose.resources.stringResource

@Composable
fun LandingApp() {
    val route = remember { parseLandingRoute(getBrowserPathname()) }
    val state = remember(route) { route.toState() }
    val kind = route.kindForLabels()

    NnodTheme {
        BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
            val isDesktop = maxWidth >= 768.dp
            NodInEndScreen(
                kind = kind,
                isDesktop = isDesktop,
                state = state,
                labels = nodInEndLabels(kind),
                onOpenApp = ::openDeepLink,
            )
        }
    }
}

@Composable
private fun nodInEndLabels(kind: NodInLandingKind): NodInEndLabels = NodInEndLabels(
    pageTitle = stringResource(Res.string.nodin_page_title),
    badge = when (kind) {
        NodInLandingKind.START -> stringResource(Res.string.nodin_start_badge)
        NodInLandingKind.END -> stringResource(Res.string.nodin_end_badge)
    },
    endTimeLabel = when (kind) {
        NodInLandingKind.START -> stringResource(Res.string.nodin_start_time_label)
        NodInLandingKind.END -> stringResource(Res.string.nodin_end_time_label)
    },
    orDivider = stringResource(Res.string.nodin_or_divider),
    codeInputLabel = stringResource(Res.string.nodin_code_input_label),
    instructionsTitle = stringResource(Res.string.nodin_instructions_title),
    instructionsStep1 = stringResource(Res.string.nodin_instructions_step1),
    instructionsStep2 = stringResource(Res.string.nodin_instructions_step2),
    openAppButton = stringResource(Res.string.nodin_open_app),
    footer = stringResource(Res.string.landing_footer),
    notFoundTitle = stringResource(Res.string.nodin_end_not_found_title),
    notFoundBody = stringResource(Res.string.nodin_end_not_found_body),
)

private fun LandingRoute.kindForLabels(): NodInLandingKind = when (this) {
    is LandingRoute.NodIn -> kind
    LandingRoute.NotFound -> NodInLandingKind.END
}

internal fun LandingRoute.toState(): NodInEndState = when (this) {
    is LandingRoute.NodIn -> NodInEndState(
        phase = NodInEndPhase.Ready(
            campaignName = eventName,
            idolName = idolName,
            scheduledEndTime = formatScheduledTimeForDisplay(scheduledTime),
            displayCode = displayCode,
            qrPayload = qrPayload(),
            appDeepLink = appDeepLink(),
        ),
    )
    LandingRoute.NotFound -> NodInEndState(NodInEndPhase.NotFound)
}
